import { autocompleteClasses, createTheme, outlinedInputClasses } from "@mui/material";

export const theme = createTheme();
